import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Building2, ArrowRight, Sparkles, LayoutGrid } from "lucide-react";

// Identifies the ACTIVE (non-archived/sample/demo) property (or count) occupying the single
// free slot so the user knows exactly what to view or archive. Never names an archived/sample/demo
// record. Does not archive anything itself.
export function PropertyLimitChoiceDialog({
  open, onOpenChange, activeProperties = [], onView, onUpgrade, onArchive, onManageAll,
}) {
  const count = activeProperties.length;
  const multi = count > 1;
  const single = activeProperties[0] || null;
  const label = (single?.address || "").trim() || "Untitled property";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="property-limit-choice">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-navy flex items-center gap-2">
            <Building2 size={18} className="text-brand" />
            {multi ? `You have ${count} active properties` : "One active property"}
          </DialogTitle>
        </DialogHeader>

        {multi ? (
          <>
            <p className="text-sm text-[#475569]" data-testid="limit-active-count">
              Your free plan includes one active property. Archive the others to start a new one.
            </p>
            <Button data-testid="choice-manage-all" onClick={onManageAll}
              className="w-full h-11 rounded-xl bg-navy hover:bg-navy-hover text-white font-semibold">
              <LayoutGrid size={16} className="mr-2" /> Manage all properties
            </Button>
            <Button data-testid="choice-upgrade" variant="outline" onClick={onUpgrade}
              className="w-full h-11 rounded-xl">
              <Sparkles size={15} className="mr-2 text-brand" /> Upgrade for unlimited properties
            </Button>
          </>
        ) : (
          <>
            <p className="text-sm text-[#475569]">Your free plan includes one active property:</p>
            <div className="rounded-xl border border-[#E2E8F0] bg-[#FAF7F2] px-4 py-3 flex items-center gap-2.5">
              <Building2 size={16} className="text-[#94A3B8] shrink-0" />
              <span data-testid="limit-active-address" className="text-sm font-semibold text-navy truncate">{label}</span>
            </div>
            <Button data-testid="choice-continue-existing" onClick={() => onView?.(single?.property_id)}
              className="w-full h-11 rounded-xl bg-navy hover:bg-navy-hover text-white font-semibold">
              View property <ArrowRight size={16} className="ml-2" />
            </Button>
            <Button data-testid="choice-upgrade" variant="outline" onClick={onUpgrade}
              className="w-full h-11 rounded-xl">
              <Sparkles size={15} className="mr-2 text-brand" /> Upgrade for unlimited properties
            </Button>
            {onArchive && single && (
              <button data-testid="choice-archive" onClick={() => onArchive(single.property_id)}
                className="text-xs text-[#64748B] hover:text-navy underline text-center">
                Or archive {label} to start a new one
              </button>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
